module.exports = __webpack_public_path__ + "static/media/sideprofile.29ec4d49.jpeg";